"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAnnualMotorWidgets = void 0;
var AnnualCarUsageChoiceWidgetWithPopup_1 = require("./AnnualCarUsageChoiceWidgetWithPopup");
var AnnualQuoteSummaryPanelWidget_1 = require("./AnnualQuoteSummaryPanelWidget");
var AnnualVehicleEditorWidget_1 = require("./AnnualVehicleEditorWidget");
var WolfMTADeclineTextOutputWidget_1 = require("./WolfMTADeclineTextOutputWidget");
var AnnualCoverRefundCancellationOutput_1 = require("./AnnualCoverRefundCancellationOutput");
var InformationBanner_1 = require("./InformationBanner");
var EditPhoneNumberPopupWidget_1 = require("./EditPhoneNumberPopupWidget");
var AnnualMotorRenewalPaymentChoiceWidget_1 = require("./renewal/AnnualMotorRenewalPaymentChoiceWidget");
var AnnualMotorRenewalPolicyDetailsWidget_1 = require("./renewal/AnnualMotorRenewalPolicyDetailsWidget");
var AnnualMotorRenewaCarDetailsWidget_1 = require("./renewal/car/AnnualMotorRenewaCarDetailsWidget");
var AnnualMotorRenewalDriverDetailsWidget_1 = require("./renewal/AnnualMotorRenewalDriverDetailsWidget");
var PolicyNumberWidget_1 = require("./renewal/PolicyNumberWidget");
var AnnualMotorPolicyDetailsWidget_1 = require("./renewal/AnnualMotorPolicyDetailsWidget");
var AnnualMotorRenewalEditCarExcessWidget_1 = require("./renewal/car/AnnualMotorRenewalEditCarExcessWidget");
var RenewalSaveSuccessModalWidget_1 = require("./renewal/RenewalSaveSuccessModalWidget");
var RenewalEditDriverPanelWidget_1 = require("./renewal/RenewalEditDriverPanelWidget");
var ProtectedNcdWidget_1 = require("./optionalExtras/ProtectedNcdWidget");
var WolfRenewalMTADeclineOutputTextWidget_1 = require("./WolfRenewalMTADeclineOutputTextWidget");
var AddressChangeBanner_1 = require("./AddressChangeBanner");
var AddressDisplayWidget_1 = require("./AddressDisplayWidget");
var AnnualCarCoverDetailsWidget_1 = require("./AnnualCarCoverDetailsWidget");
var AnnualPremiumChoiceWidget_1 = require("./AnnualPremiumChoiceWidget");
var AutomaticRenewalCheckboxWidget_1 = require("./AutomaticRenewalCheckboxWidget");
var DisplayAnnualCarDetailsWidget_1 = require("./DisplayAnnualCarDetailsWidget");
var EditDriverPanelWidget_1 = require("./EditDriverPanelWidget");
var ForcedPaymentPlanChangeModalWidget_1 = require("../common/ForcedPaymentPlanChangeModalWidget");
var FutureMTAHeadUpBanner_1 = require("./FutureMTAHeadUpBanner");
var PreContractCreditAgreement_1 = require("./PreContractCreditAgreement");
var ReplaceCarStartDateWarningWidget_1 = require("./ReplaceCarStartDateWarningWidget");
var VehicleDeclineModalWidget_1 = require("./VehicleDeclineModalWidget");
var WolfCarPanelWidget_1 = require("./WolfCarPanelWidget");
var WolfEditCarPanelExcessWidget_1 = require("./WolfEditCarPanelExcessWidget");
var AnnualMotorOptionalExtrasWidget_1 = require("./optionalExtras/AnnualMotorOptionalExtrasWidget");
var BreakdownCoverLevelSelectModalWidget_1 = require("./optionalExtras/BreakdownCoverLevelSelectModalWidget");
var CourtesyCarLevelSelectModalWidget_1 = require("./optionalExtras/CourtesyCarLevelSelectModalWidget");
var SupportPortalMTADeclineTextOutputWidget_1 = require("../../supportPortal/SupportPortalMTADeclineTextOutputWidget");
var SupportPortalRenewalMTADeclineTextOutputWidget_1 = require("../../supportPortal/SupportPortalRenewalMTADeclineTextOutputWidget");
var AnnualProductPaymentChoiceWidget_1 = require("../common/AnnualProductPaymentChoiceWidget");
var DrivingExperienceQuestionWidget_1 = require("./DrivingExperienceQuestionWidget");
var TierSummaryWidget_1 = require("../common/TierSummaryWidget");
var AnnualMotorTierWidget_1 = require("./AnnualMotorTierWidget");
var IncludedAsStandardWidget_1 = require("../../motorCommon/IncludedAsStandardWidget");
var RatingsAndAwardsWidget_1 = require("../common/RatingsAndAwardsWidget");
var RenewalPremiumTypeChangeModal_1 = require("./renewal/RenewalPremiumTypeChangeModal");
var YoutubeInstructionVideoBannerWidget_1 = require("./YoutubeInstructionVideoBannerWidget");
var RenewalMonthlyPaymentPlanOutput_1 = require("../common/RenewalMonthlyPaymentPlanOutput");
var AutomaticRenewalCancellationReasonWidget_1 = require("./AutomaticRenewalCancellationReasonWidget");
var CancelPolicyOrAutomaticRenewalChoiceWidget_1 = require("./CancelPolicyOrAutomaticRenewalChoiceWidget");
var TierSummaryRenewalWidget_1 = require("./renewal/car/TierSummaryRenewalWidget");
var DirectDebitProposalWidget_1 = require("./DirectDebitProposalWidget");
var PolicyDocumentSectionWidget_1 = require("../../motorCommon/PolicyDocumentSectionWidget");
var AnnualMotorEligibleTiersWarningModal_1 = require("./AnnualMotorEligibleTiersWarningModal");
var OnlySingleEligibleTierWidget_1 = require("./OnlySingleEligibleTierWidget");
var AnnualMotorSummaryPagePremiumWidget_1 = require("./AnnualMotorSummaryPagePremiumWidget");
var AnnualMotorPriceWidget_1 = require("./AnnualMotorPriceWidget");
var AnnualMotorReplaceCarSummaryPanelWidget_1 = require("./AnnualMotorReplaceCarSummaryPanelWidget");
var AnnualCoverPriceToPayCancellationOutput_1 = require("./AnnualCoverPriceToPayCancellationOutput");
var AnnualMotorTierDeclinePanelWidget_1 = require("./AnnualMotorTierDeclinePanelWidget");
var AnnualCoverCancellationWordingOutput_1 = require("./AnnualCoverCancellationWordingOutput");
var ForcedCancellationRefundWording_1 = require("./ForcedCancellationRefundWording");
var ExtrasMotorCarouselWidget_1 = require("./optionalExtras/ExtrasMotorCarouselWidget");
var DrivingLicenceNotFoundModalWidget_1 = require("./DrivingLicenceNotFoundModalWidget");
var DrivingLicenceNotFoundAlertWidget_1 = require("./DrivingLicenceNotFoundAlertWidget");
var DrivingLicencePriceUpdateModalWidget_1 = require("./DrivingLicencePriceUpdateModalWidget");
var addAnnualMotorWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "annualCarUsageChoiceWidgetWithPopup",
        component: AnnualCarUsageChoiceWidgetWithPopup_1.AnnualCarUsageChoiceWidgetWithPopup
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "extrasMotorCarousel",
        component: ExtrasMotorCarouselWidget_1.ExtrasMotorCarouselWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorReplaceCarSummaryPanelWidget",
        component: AnnualMotorReplaceCarSummaryPanelWidget_1.AnnualMotorReplaceCarSummaryPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualQuoteSummaryPanel",
        component: AnnualQuoteSummaryPanelWidget_1.AnnualQuoteSummaryPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualVehicleEdit",
        component: AnnualVehicleEditorWidget_1.AnnualVehicleEditorWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfMTADeclineTextOutputWidget",
        component: WolfMTADeclineTextOutputWidget_1.WolfMTADeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfRenewalMTADeclineTextOutputWidget",
        component: WolfRenewalMTADeclineOutputTextWidget_1.WolfRenewalMTADeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalMTADeclineTextOutputWidget",
        component: SupportPortalMTADeclineTextOutputWidget_1.SupportPortalMTADeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalRenewalMTADeclineTextOutputWidget",
        component: SupportPortalRenewalMTADeclineTextOutputWidget_1.SupportPortalRenewalMTADeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualCoverRefundCancellationOutput",
        component: AnnualCoverRefundCancellationOutput_1.AnnualCoverRefundCancellationOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualCoverPriceToPayCancellationOutput",
        component: AnnualCoverPriceToPayCancellationOutput_1.AnnualCoverPriceToPayCancellationOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfInformationBanner",
        component: InformationBanner_1.InformationBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editPhoneNumberPopup",
        component: EditPhoneNumberPopupWidget_1.EditPhoneNumberPopupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "youtubeInstructionVideoBanner",
        component: YoutubeInstructionVideoBannerWidget_1.YoutubeInstructionVideoBannerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalPaymentChoice",
        component: AnnualMotorRenewalPaymentChoiceWidget_1.AnnualMotorRenewalPaymentChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorPolicyDetails",
        component: AnnualMotorPolicyDetailsWidget_1.AnnualMotorPolicyDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalPolicyDetails",
        component: AnnualMotorRenewalPolicyDetailsWidget_1.AnnualMotorRenewalPolicyDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalCarDetails",
        component: AnnualMotorRenewaCarDetailsWidget_1.AnnualMotorRenewalCarDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalDriverDetails",
        component: AnnualMotorRenewalDriverDetailsWidget_1.AnnualMotorRenewalDriverDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "policyNumber",
        component: PolicyNumberWidget_1.PolicyNumberWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalEditCarExcess",
        component: AnnualMotorRenewalEditCarExcessWidget_1.AnnualMotorRenewalEditCarExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "tierSummaryRenewalWidget",
        component: TierSummaryRenewalWidget_1.TierSummaryRenewalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalSaveSuccessModalWidget",
        component: RenewalSaveSuccessModalWidget_1.RenewalSaveSuccessModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalEditDriverPanel",
        component: RenewalEditDriverPanelWidget_1.RenewalEditDriverPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "protectedNcdWidget",
        component: ProtectedNcdWidget_1.ProtectedNcdWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressChangeBanner",
        component: AddressChangeBanner_1.AddressChangeBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressDisplay",
        component: AddressDisplayWidget_1.AddressDisplayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualCarCoverDetailsOutput",
        component: AnnualCarCoverDetailsWidget_1.AnnualCarCoverDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualProductPaymentChoice",
        component: AnnualProductPaymentChoiceWidget_1.AnnualProductPaymentChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "tierSummaryWidget",
        component: TierSummaryWidget_1.TierSummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "motorIncludedAsStandardWidget",
        component: IncludedAsStandardWidget_1.IncludedAsStandardWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorTierWidget",
        component: AnnualMotorTierWidget_1.AnnualMotorTierWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitProposalWidget",
        component: DirectDebitProposalWidget_1.DirectDebitProposalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualPremiumChoice",
        component: AnnualPremiumChoiceWidget_1.AnnualPremiumChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "ratingsAndAwardsWidget",
        component: RatingsAndAwardsWidget_1.RatingsAndAwardsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "automaticRenewalCheckboxWidget",
        component: AutomaticRenewalCheckboxWidget_1.AutomaticRenewalCheckboxWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "displayAnnualCarDetails",
        component: DisplayAnnualCarDetailsWidget_1.DisplayAnnualCarDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editDriverPanel",
        component: EditDriverPanelWidget_1.EditDriverPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "forcedPaymentPlanChangeModal",
        component: ForcedPaymentPlanChangeModalWidget_1.ForcedPaymentPlanChangeModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "futureMtaHeadUpPanel",
        component: FutureMTAHeadUpBanner_1.FutureMTAHeadUpBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "preContractCreditAgreement",
        component: PreContractCreditAgreement_1.PreContractCreditAgreement
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "replaceCarStartDateWarning",
        component: ReplaceCarStartDateWarningWidget_1.ReplaceCarStartDateWarningWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "vehicleDeclineModal",
        component: VehicleDeclineModalWidget_1.VehicleDeclineModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfCarPanelOutput",
        component: WolfCarPanelWidget_1.WolfCarPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfEditCarExcessOutput",
        component: WolfEditCarPanelExcessWidget_1.WolfEditCarExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorSummaryPagePremiumOutput",
        component: AnnualMotorSummaryPagePremiumWidget_1.AnnualMotorSummaryPagePremiumWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorPriceOutput",
        component: AnnualMotorPriceWidget_1.AnnualMotorPriceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "optionalExtrasAnnualMotor",
        component: AnnualMotorOptionalExtrasWidget_1.AnnualMotorOptionalExtrasWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "breakdownCoverLevelSelectModal",
        component: BreakdownCoverLevelSelectModalWidget_1.BreakdownCoverLevelSelectModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "courtesyCarLevelSelectModal",
        component: CourtesyCarLevelSelectModalWidget_1.CourtesyCarLevelSelectModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "drivingExperienceQuestion",
        component: DrivingExperienceQuestionWidget_1.DrivingExperienceQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalPremiumTypeChangeModal",
        component: RenewalPremiumTypeChangeModal_1.RenewalPremiumTypeChangeModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalMonthlyPaymentPlanOutput",
        component: RenewalMonthlyPaymentPlanOutput_1.RenewalMonthlyPaymentPlanOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalCancellationReasons",
        component: AutomaticRenewalCancellationReasonWidget_1.AutomaticRenewalCancellationReasonWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancelPolicyOrAutomaticRenewalChoiceWidget",
        component: CancelPolicyOrAutomaticRenewalChoiceWidget_1.CancelPolicyOrAutomaticRenewalChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "policyDocumentSectionWidget",
        component: PolicyDocumentSectionWidget_1.PolicyDocumentSectionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorEligibleTiersWarningModal",
        component: AnnualMotorEligibleTiersWarningModal_1.AnnualMotorEligibleTiersWarningModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "onlySingleEligibleTierWidget",
        component: OnlySingleEligibleTierWidget_1.OnlySingleEligibleTierWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "motorTierDeclinePanel",
        component: AnnualMotorTierDeclinePanelWidget_1.AnnualMotorTierDeclinePanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualCoverCancellationWordingOutput",
        component: AnnualCoverCancellationWordingOutput_1.AnnualCoverCancellationWordingOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "forcedCancellationRefundCPOutput",
        component: ForcedCancellationRefundWording_1.ForcedCancellationRefundWording
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "drivingLicencePriceUpdateModal",
        component: DrivingLicencePriceUpdateModalWidget_1.DrivingLicencePriceUpdateModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "drivingLicenceNotFoundModal",
        component: DrivingLicenceNotFoundModalWidget_1.DrivingLicenceNotFoundModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "drivingLicenceNotFoundAlert",
        component: DrivingLicenceNotFoundAlertWidget_1.DrivingLicenceNotFoundAlertWidget
    });
};
exports.addAnnualMotorWidgets = addAnnualMotorWidgets;
//# sourceMappingURL=index.js.map